import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { TextEntry } from '@jump-tools-front/shared-interfaces';
// noinspection ES6PreferShortImport
import { TextsState } from '../../stores/text';

@Pipe({
  name: 'wording',
  standalone: true,
})
export class WordingPipe implements PipeTransform {
  private _store = inject(Store);
  defaultTexts: TextEntry[];

  constructor() {
    const texts = this._store.selectSnapshot(TextsState.getAll);
    if (texts) {
      this.defaultTexts = texts;
    } else {
      console.error('No default text');
    }
  }

  transform(slug: string): string {
    const correspondingEntry = this.defaultTexts?.find(entry => entry.slug === slug);
    if (!correspondingEntry) {
      console.error(`No entry for slug ${slug}`);
      return '';
    }
    return correspondingEntry.value;
  }
}
